import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PanelId = 'summary' | 'cargos' | 'map' | 'shop' | 'cart' | 'order-history' | 'journeys' | 'support' | 'settings' | 'open-investments';
export type NavGroup = 'investor' | 'shop' | null;

export type DashboardUiState = {
  activePanel: PanelId;
  activeGroup: NavGroup;
  selectedCargoId: string | null;
};

const initialState: DashboardUiState = {
  activePanel: 'summary',
  activeGroup: 'investor',
  selectedCargoId: null,
};

const dashboardUiSlice = createSlice({
  name: 'dashboardUi',
  initialState,
  reducers: {
    setActivePanel(state, action: PayloadAction<PanelId>) {
      state.activePanel = action.payload;
      if (['summary', 'cargos', 'map'].includes(action.payload)) state.activeGroup = 'investor';
      else if (['shop', 'cart', 'order-history'].includes(action.payload)) state.activeGroup = 'shop';
      else state.activeGroup = null;
    },
    setActiveGroup(state, action: PayloadAction<NavGroup>) {
      state.activeGroup = action.payload;
      if (action.payload === 'investor') state.activePanel = 'summary';
      else if (action.payload === 'shop') state.activePanel = 'shop';
    },
    setSelectedCargoId(state, action: PayloadAction<string | null>) {
      state.selectedCargoId = action.payload;
    },
  },
});

export const { setActivePanel, setActiveGroup, setSelectedCargoId } = dashboardUiSlice.actions;
export default dashboardUiSlice.reducer;
